import {
  ButtonBase,
  ButtonProps,
  Tooltip,
  useColorMode,
} from '@tonic-one/react';
import React from 'react';

// Icon button, use this component with Tonic <Icon />
const IconButton = React.forwardRef<
  HTMLElement,
  { children: React.ReactNode; tooltipLabel?: string } & ButtonProps
>((props, ref) => {
  const [colorMode] = useColorMode();
  const color = (
    {
      dark: 'white:primary',
      light: 'black:primary',
    } as any
  )[colorMode];
  const hoverColor = (
    {
      dark: 'blue:40',
      light: 'blue:40',
    } as any
  )[colorMode];
  const activeColor = color;

  return (
    <Tooltip
      label={props.tooltipLabel}
      maxWidth="400px"
      offset={[0, 0]}
      PopperProps={{
        modifiers: [
          {
            // https://popper.js.org/docs/v2/modifiers/flip/
            name: 'flip',
            enabled: true,
          },
        ],
      }}
    >
      <ButtonBase
        ref={ref}
        border={0}
        borderColor="transparent"
        color={color}
        transition="all .2s"
        lineHeight={1}
        px="1x"
        py="1x"
        _hover={{ color: hoverColor }}
        _active={{ color: activeColor }}
        {...props}
        _disabled={{
          opacity: 0.28, // dark: 0.28, light: 0.3
          cursor: 'not-allowed',
        }}
      />
    </Tooltip>
  );
});

export default IconButton;
